import React from 'react';
import PermissionGuard from '../components/PermissionGuard';

export default function ApprovedEvents() {
  const dummyEvents = [
    {
      id: '1',
      title: 'Summer Music Fest',
      date: '2025-08-15',
      location: 'Mumbai',
      status: 'Approved'
    },
    {
      id: '2',
      title: 'Indie Rock Night',
      date: '2025-09-05',
      location: 'Bangalore',
      status: 'Approved'
    }
  ];

  return (
    <PermissionGuard requiredPermission="view_approved_events">
      <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
        <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem' }}>
          Approved Events
        </h2>

        <div style={{
          overflowX: 'auto',
          border: '1px solid #ccc',
          borderRadius: '8px',
          backgroundColor: '#fff'
        }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ backgroundColor: '#f5f5f5' }}>
              <tr>
                <th style={thStyle}>Title</th>
                <th style={thStyle}>Date</th>
                <th style={thStyle}>Location</th>
                <th style={thStyle}>Status</th>
              </tr>
            </thead>
            <tbody>
              {dummyEvents.map(event => (
                <tr key={event.id}>
                  <td style={tdStyle}>{event.title}</td>
                  <td style={tdStyle}>{event.date}</td>
                  <td style={tdStyle}>{event.location}</td>
                  <td style={tdStyle}>
                    <span style={{
                      backgroundColor: '#c8e6c9',
                      color: '#1b5e20',
                      padding: '0.4rem 0.7rem',
                      borderRadius: '6px',
                      fontWeight: 'bold'
                    }}>
                      {event.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </PermissionGuard>
  );
}

// 🔧 Styles
const thStyle = {
  padding: '0.75rem',
  textAlign: 'left',
  fontWeight: 'bold',
  borderBottom: '1px solid #ddd'
};

const tdStyle = {
  padding: '0.75rem',
  borderBottom: '1px solid #eee',
  fontSize: '0.95rem'
};
